import React, { forwardRef } from "react";
import { Close } from "@mui/icons-material";
import { Button, IconButton, Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";

import { useDispatch, useSelector } from "react-redux";
import {
  closeErrorSnack,
  closeSnackBar,
  openErrorSnack,
  openSnackBar,
} from "../../features/modals/snackBarSlice";

const SnackBar = () => {
  const {
    openSnack,
    message,
    vertical,
    horizontal,
    openErrorSnackBar,
    autoHideDuration,
    severity,
  } = useSelector((state) => state.snackBar);
  const dispatch = useDispatch();

  //   const Alert = forwardRef((props, ref) => {
  //     return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  //   });

  //   const Alert = forwardRef(function Alert(props, ref) {
  //     return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  //   });

  //   const handleOpenSnackbar = () => {
  //     dispatch(openSnackBar("successfully edited"));
  //   };
  const handleCloseSnackBar = (e, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(closeSnackBar());
  };

  const handleCloseErrorSnackBar = (e, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(closeErrorSnack());
  };

  const action = (
    <>
      <Button color="error" size="small" onClick={handleCloseSnackBar}>
        Close
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="error"
        onClick={handleCloseSnackBar}
      >
        <Close fontSize="small" />
      </IconButton>
    </>
  );

  const errorAction = (
    <>
      <Button color="error" size="small" onClick={handleCloseErrorSnackBar}>
        Close
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="error"
        onClick={handleCloseErrorSnackBar}
      >
        <Close fontSize="small" />
      </IconButton>
    </>
  );

  return (
    <>
      <Snackbar
        open={openSnack}
        autoHideDuration={autoHideDuration}
        onClose={handleCloseSnackBar}
        message={message}
        action={action}
        anchorOrigin={{ vertical, horizontal }}
        // severity={severity}
        // color="success"
      />

      {/* <SnackBar
        open={openSnack}
        autoHideDuration={autoHideDuration}
        onClose={handleCloseSnackBar}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          onClose={handleCloseSnackBar}
          severity="success"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </SnackBar> */}

      <Snackbar
        open={openErrorSnackBar}
        autoHideDuration={autoHideDuration}
        onClose={handleCloseErrorSnackBar}
        message={message}
        action={errorAction}
        anchorOrigin={{ vertical, horizontal }}
        // severity={severity}
        // color="success"
      />
    </>
  );
};

export default SnackBar;
